import { render, staticRenderFns } from "./CheckboxBase.vue?vue&type=template&id=e979be2e&scoped=true&lang=pug&"
import script from "./CheckboxBase.vue?vue&type=script&lang=ts&"
export * from "./CheckboxBase.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxBase.vue?vue&type=style&index=0&id=e979be2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e979be2e",
  null
  
)

export default component.exports